<template>
  <v-menu
    v-model="isVisible"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <a v-on="on" @click="tmpPrice = exportPrice">
        <v-icon v-if="!isLoading" small>$pencil</v-icon>
        <span v-else >
              <v-progress-circular
                  size="16"
                  indeterminate
                  color="primary"
              ></v-progress-circular>
        </span>
      </a>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-form ref="form">
              <v-text-field
                :placeholder="$t('common.price')"
                v-model="tmpPrice"
                required
                type="numeric"
                :rules="[
                  (v) =>
                  (v === '' || v === null || v === undefined) ||
                    (v &&
                      v.replace(/,/g, '.') ==
                        parseFloat(v.replace(/,/g, '.'))) ||
                    $t('form.validationErrors.must_be_float'),
                ]"
              ></v-text-field>
            </v-form>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="isVisible = false">{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" text @click="setExportPrice()">
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "NomenclatureExportPriceMenu",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    exportPrice: null,
  },
  data: () => ({
    tmpPrice: null,
  }),
  mounted() {},
  methods: {
    close() {
      this.showWindow = false;
    },
    submit() {},
    setExportPrice(price) {
      if (this.$refs["form"].validate()) {
        this.isVisible = false;
        this.$emit("set-price", this.tmpPrice);
      }
    },
  },
  watch: {
    isVisible() {
      if (this.$refs["form"]) {
        this.$refs["form"].reset();
      }
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.show;
      },
      set(to) {
        this.$emit("update:show", to);
      },
    },
  },
};
</script>

<style scoped></style>
